import { render, staticRenderFns } from "./send-rule-add.vue?vue&type=template&id=8819c4d0&scoped=true&"
import script from "./send-rule-add.vue?vue&type=script&lang=js&"
export * from "./send-rule-add.vue?vue&type=script&lang=js&"
import style0 from "./send-rule-add.vue?vue&type=style&index=0&id=8819c4d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8819c4d0",
  null
  
)

export default component.exports